import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { OfferProvider } from "@/context/OfferContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import Services from "@/pages/Services";
import Contact from "@/pages/Contact";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Account from "@/pages/Account";
import Admin from "@/pages/Admin";
import SellMachine from "@/pages/SellMachine";
import MyListings from "@/pages/MyListings";
import Listings from "@/pages/Listings";
import RequestsWall from "@/pages/RequestsWall";
import Directory from "@/pages/Directory";
import CompanyProfile from "@/pages/CompanyProfile";
import AdvisorChat from "@/pages/AdvisorChat";
import TokenShop from "@/pages/TokenShop";
import News from "@/pages/News";
import NewsArticle from "@/pages/NewsArticle";
import ListingDetail from "@/pages/ListingDetail";
import Experts from "@/pages/Experts";
import ExpertDetail from "@/pages/ExpertDetail";
import ExpertProfile from "@/pages/ExpertProfile";
import SponsorProfile from "@/pages/SponsorProfile";
import SponsorDetail from "@/pages/SponsorDetail";
import Community from "@/pages/Community";
import ArvaSzakmak from "@/pages/ArvaSzakmak";
import PremiumReport from "@/pages/PremiumReport";
import ConsultationPayment from "@/pages/ConsultationPayment";
import LegalPage from "@/pages/LegalPage";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Pricing from "@/pages/Pricing";
import Referral from "@/pages/Referral";
import ProtectedRoute from "@/components/ProtectedRoute";
import Analytics from "@/components/Analytics";

function ReferralCapture() {
  useEffect(() => {
    const ref = new URLSearchParams(window.location.search).get("ref");
    if (ref && ref !== localStorage.getItem("oxo_ref")) {
      localStorage.setItem("oxo_ref", ref);
      import("@/lib/api").then(({ default: api }) => api.post("/referral/track", { code: ref }).catch(() => {}));
    }
  }, []);
  return null;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CartProvider>
          <OfferProvider>
          <BrowserRouter>
            <ReferralCapture />
            <Analytics />
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/produse" element={<Catalog />} />
                <Route path="/produse/:id" element={<ProductDetail />} />
                <Route path="/cos" element={<Cart />} />
                <Route path="/comanda-succes" element={<CheckoutSuccess />} />
                <Route path="/servicii" element={<Services />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/preturi" element={<Pricing />} />
                <Route path="/referral" element={<ProtectedRoute><Referral /></ProtectedRoute>} />
                <Route path="/anunturi" element={<Listings />} />
                <Route path="/cereri" element={<RequestsWall />} />
                <Route path="/directory" element={<Directory />} />
                <Route path="/directory/:id" element={<CompanyProfile />} />
                <Route path="/consilier" element={<ProtectedRoute><AdvisorChat /></ProtectedRoute>} />
                <Route path="/tokens" element={<ProtectedRoute><TokenShop /></ProtectedRoute>} />
                <Route path="/news" element={<News />} />
                <Route path="/news/:slug" element={<NewsArticle />} />
                <Route path="/anunt/:id" element={<ListingDetail />} />
                <Route path="/experti" element={<Experts />} />
                <Route path="/expert/:id" element={<ExpertDetail />} />
                <Route path="/cont-expert" element={<ProtectedRoute><ExpertProfile /></ProtectedRoute>} />
                <Route path="/cont-sponsor" element={<ProtectedRoute><SponsorProfile /></ProtectedRoute>} />
                <Route path="/sponsor/:id" element={<SponsorDetail />} />
                <Route path="/comunitate" element={<Community />} />
                <Route path="/arva-szakmak" element={<ArvaSzakmak />} />
                <Route path="/raport-ai" element={<ProtectedRoute><PremiumReport /></ProtectedRoute>} />
                <Route path="/plata-consultanta/:id" element={<ConsultationPayment />} />
                <Route path="/vinde" element={<ProtectedRoute><SellMachine /></ProtectedRoute>} />
                <Route path="/anunturile-mele" element={<ProtectedRoute><MyListings /></ProtectedRoute>} />
                <Route path="/autentificare" element={<Login />} />
                <Route path="/inregistrare" element={<Register />} />
                <Route path="/recuperare-parola" element={<ForgotPassword />} />
                <Route path="/reseteaza-parola" element={<ResetPassword />} />
                <Route path="/termeni-si-conditii" element={<LegalPage doc="terms" />} />
                <Route path="/confidentialitate" element={<LegalPage doc="privacy" />} />
                <Route path="/politica-retur" element={<LegalPage doc="refund" />} />
                <Route path="/cont" element={<ProtectedRoute><Account /></ProtectedRoute>} />
                <Route path="/admin" element={<ProtectedRoute admin><Admin /></ProtectedRoute>} />
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" richColors />
          </OfferProvider>
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
